'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styles = require('@material-ui/styles');
var CircleLoader = require('../CircleLoader/CircleLoader.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = styles.makeStyles({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
});
var MenuPanelLoader = () => {
  var classes = useStyles();
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React__default['default'].createElement(CircleLoader.CircleLoader, {
    size: 64
  }));
};

exports.MenuPanelLoader = MenuPanelLoader;
exports.default = MenuPanelLoader;
